import ReadyToShip from './ReadyToShip';

export default ReadyToShip;
